/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListResourceEnum } from './listResourceEnum';


/**
 * Data payload for \'list.changed\': objects of ``resource`` were created, deleted or changed in shown fields.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface ListChangedData { 
    resource: ListResourceEnum;
    ids: Array<number>;
    patientIds: Array<number>;
    /**
     * New objects, which may now belong in a filtered list
     */
    created: boolean;
    /**
     * Too many to list: ids and patientIds are empty
     */
    many: boolean;
}
export namespace ListChangedData {
}

export const ListChangedData_resource_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ListChangedData_ids_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ListChangedData_patientIds_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ListChangedData_created_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ListChangedData_many_Validators: ValidatorFn[] =
    [  Validators.required, ];


